import { reduce } from 'lodash';
import { compose, withState, withHandlers } from 'recompose';
import PayFac, { DEFAULT_ICON } from '../../utils/payFac';
import analytics from '../../applicationServices/analytics/BookingAnalytics';

export default () => {
  const payFac = new PayFac();

  return compose(
    withState('payFacInputErrors', 'setPayFacInputErrors', {}),
    withState('hasErrors', 'setHasErrors', false),
    withState('payFacInputsDisabled', 'setPayFacInputsDisabled', false),
    withState('cardBrand', 'setCardBrand', 'unknown'),
    withState('cardBrandIcon', 'setCardBrandIcon', DEFAULT_ICON),
    withState('cardNumber', 'setCardNumber', ''),
    withState('cardExpiry', 'setCardExpiry', ''),
    withState('cardCvc', 'setCardCvc', ''),
    withState('zipCode', 'setZipCode', ''),
    withState('cardExpiryRef', 'setCardExpiryRef', null),
    withState('cardCvcRef', 'setCardCvcRef', null),
    withState('zipCodeRef', 'setZipCodeRef', null),
    withHandlers({
      updateErrors: props => (error) => {
        const errors = {
          ...props.payFacInputErrors,
          ...error,
        };

        const hasErrors = !!(reduce(errors, (memo, err) => (memo || err), false));

        props.setPayFacInputErrors(errors);
        props.setHasErrors(hasErrors);
        return hasErrors;
      },
    }),
    withHandlers({
      onCardNumberChange: props => (cardNumber, checkPotentiallyValid = false) => {
        const validation = payFac.validateCardNumber(cardNumber, checkPotentiallyValid);
        props.setCardBrand(validation.card && validation.card.type ? validation.card.type : 'unknown');
        props.setCardBrandIcon(validation.brandIcon);
        props.setCardNumber(validation.formatted || '');
        props.updateErrors({ cardNumber: validation.error });

        if (validation.isValid) {
          analytics.fillCardInfoField('cardNumber');
          props.cardExpiryRef.focus();
        }
      },
      onCardExpiryChange: props => (expiry, checkPotentiallyValid = false) => {
        const validation = payFac.validateCardExpiry(expiry, checkPotentiallyValid);
        props.setCardExpiry(validation.formatted || '');
        props.updateErrors({ cardExpiry: validation.error });

        if (validation.isValid) {
          analytics.fillCardInfoField('cardExpiry');
          props.cardCvcRef.focus();
        }
      },
      onCardCvcChange: props => (cvc, checkPotentiallyValid = false) => {
        const validation = payFac.validateCardCvc(cvc, props.cardNumber, checkPotentiallyValid);
        props.setCardCvc(validation.formattedCvc || '');
        props.updateErrors({ cardCvc: validation.cvcError });

        if (validation.card && validation.card && cvc.length === validation.card.code.size) {
          analytics.fillCardInfoField('cardCvc');
          props.zipCodeRef.focus();
        }
      },
      validateZipCode: props => zipCode =>
        props.updateErrors({ zipCode: zipCode ? null : 'Zip/postal code is required' }),
    }),
  );
};



// WEBPACK FOOTER //
// ./src/app/reservation/containers/withPayFacInput.js